<template>
    <el-dialog v-dialogDrag title="添加AI服务" :visible.sync="dialogVisible" width="40%" :modal="true"
        :modal-append-to-body="false" :appen-to-body="true" :top="dlgtop">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <el-form-item prop="ai_name" label="名称:">
                <el-input v-model="form.ai_name" placeholder="请输入AI名称"></el-input>
            </el-form-item>
            <el-form-item prop="file" label="图标:">
                <input type="file" ref="fileInput" style="display: none" @change="handleFileChange">
                <div style="display: flex; align-items: center">
                    <el-input :disabled="true" type="text" v-model="form.ai_pic" style="flex: 1;width: 300px"></el-input>
                    <el-button type="primary" @click="uploadFile">上传文件</el-button>
                </div>
            </el-form-item>
            <el-form-item prop="ai_describe" label="描述:">
                <el-input type="textarea" :rows="1" placeholder="请输入内容" v-model="form.ai_describe">
                </el-input>
            </el-form-item>
        </el-form>
        <div class="toos_layer_footer">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button type="primary" @click="cancel">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: [
        'list'
    ],
    data() {
        return {
            dialogVisible: false,
            form: {
                ai_name: '',
                ai_pic: '',
            },
            rules: {
                ai_name: [
                    { required: true, message: '请输入AI名称', trigger: 'blur' },
                ],
            },
            dlgtop: (window.innerHeight - 320) / 2 + "px",
        }
    },
    computed: {},
    mounted() { },
    methods: {
        uploadFile() {
            this.$refs.fileInput.click();
        },
        async handleFileChange() {
            const formData = new FormData();
            formData.append('file', this.$refs.fileInput.files[0]);
            this.form.ai_pic = await this.upload(formData)
        },
        async upload(formdata) {
            try {
                //localStorage.getItem('enterprise_id')
                const res = await this.$axios.post(this.$baseUrl.filesupload + '/public/AIserve/', formdata, {
                    headers: {
                        'token': localStorage.getItem("token"),
                        'content-type': 'multipart/form-data'
                    }
                });
                if (res.data.code == 0) {
                    return res.data.data[res.data.data.length - 1].upload_path;
                }
            } catch (err) {

            }
        },
        init() {
            Object.keys(this.form).forEach((key) => {
                this.form[key] = "";
            });
            this.dialogVisible = true
        },
        cancel() {
            this.dialogVisible = false
        },
        // 点击确定
        confirm() {
            this.$tools
                .asyncPost(this, this.$baseUrl.aiserviceadd, {
                    data: {
                        ...this.form
                    }
                }, true)
                .then((res) => {
                    if (res.data.code == 0) {
                        this.$emit('list')
                        this.dialogVisible = false
                        this.$message({ type: "success", message: res.data.msg });
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                });
        }
    }
}
</script>


